import $ from 'jquery';
import _ from 'lodash';
import { getHeight, getScrollTop } from '../utils/window';

export default function sideNav() {
	const $html = $('html');
   const $scroller = $('html, body');
   
   const NAV = $('.navigation');
   const NAV_MENU_BTN = NAV.find('.menu .btn');
   const NAV_CLICKABLE = NAV.find('.clickable');

   var documentScrollTop = 0;

   const toggleMenu = function() {
      NAV_MENU_BTN.toggleClass('is-open');
      NAV.toggleClass('is-active');

      if(NAV.hasClass('is-active')) {
         // documentScrollTop = getScrollTop();
         // $('body').css('height', getHeight() + 'px');
         $('body').css('overflow', 'hidden');
      } else {
         // $('body').css('height', '');
         $('body').css('overflow', '');
         // $('html, body').animate({ scrollTop: documentScrollTop }, 'fast');
      }
   }

   NAV_MENU_BTN.click(_.debounce(function(){
      toggleMenu();
   }, 100));

   NAV_CLICKABLE.click(_.debounce(function(){
      toggleMenu();
   }, 100));

}



// WEBPACK FOOTER //
// ./source/scripts/sections/side-navigation.js